(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["metafield-accordion-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('metafield-accordion-video')) {
    customElements.define('metafield-accordion-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.details = this.closest('details');
        if (!this.video || !this.details) return;
        this.onToggle = () => {
          if (!this.details.open) {
            this.video.pause();
            return;
          }
          if (this.video.ended) this.video.currentTime = 0;
          this.video.play().catch(() => {});
        };
        this.onPlay = () => {
          if (!this.details.open) this.video.pause();
        };
        this.details.addEventListener('toggle', this.onToggle);
        this.video.addEventListener('play', this.onPlay);
      }
      disconnectedCallback() {
        this.details?.removeEventListener('toggle', this.onToggle);
        this.video?.removeEventListener('play', this.onPlay);
        this.video?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-line-banner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-line-banner')) {
    customElements.define('product-line-banner', class extends HTMLElement {
      connectedCallback() {
        if (this.trackClick) return;
        this.trackClick = (event) => {
          const link = event.target.closest('[data-line-registration]');
          if (!link || (event.type === 'auxclick' && event.button !== 1)) return;
          const parameters = {
            link_url: link.href,
            link_id: 'product_line_banner',
            product_id: this.dataset.productId
          };
          try {
            if (typeof window.gtag === 'function') {
              window.gtag('event', 'line_registration_click', parameters);
            } else if (Array.isArray(window.dataLayer)) {
              window.dataLayer.push({ event: 'line_registration_click', ...parameters });
            }
          } catch {}
          try {
            if (typeof window.clarity === 'function') {
              window.clarity('event', 'line_registration_click');
            }
          } catch {}
        };
        this.addEventListener('click', this.trackClick);
        this.addEventListener('auxclick', this.trackClick);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.trackClick);
        this.removeEventListener('auxclick', this.trackClick);
        this.trackClick = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-story-image"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('craft-point-video')) {
    customElements.define('craft-point-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.slider = this.closest('slider-component');
        this.onSlideChanged = (event) => {
          const current = event?.detail?.currentElement;
          if (current && current.contains(this)) return;
          if (!this.video.paused) this.video.pause();
        };
        this.slider?.addEventListener('slideChanged', this.onSlideChanged);
        this.onPlay = () => {
          const scope = this.closest('.product-craftsmanship__item') || document;
          scope.querySelectorAll('craft-point-video video').forEach((other) => {
            if (other !== this.video && !other.paused) other.pause();
          });
        };
        this.video.addEventListener('play', this.onPlay);
      }
      disconnectedCallback() {
        this.slider?.removeEventListener('slideChanged', this.onSlideChanged);
        this.video?.removeEventListener('play', this.onPlay);
        this.video?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
